import React from 'react';
import './FBXButtonVertical.style.scss';

const FBXButtonVertical = ({
    buttonID,
    expanded,
    expandedText,
    expandedColor,
    hasIcon,
    IconText,
    buttonIcon,
    isSelected,
    buttonColor,
    textColor,
    theTooltip,
    onClick,
    marginTop,
}) => {

    const handleToggle = (event) => {
        if (onClick) {
          onClick(event, buttonID); // Pass event and buttonID to parent onClick handler
        }
    };

    return (
        expanded ? (
            <div
                title={theTooltip}
                onClick={handleToggle}
                className={`round-button-vert ${hasIcon === true ? 'icon' : 'isText'}`}
                style={{
                    backgroundColor: isSelected ? 'orange' : buttonColor || 'transparent', // Default to transparent if buttonColor is not set
                    color: textColor || 'white',
                    marginBottom: "5px",
                    marginTop: marginTop || '0px',
                }}
            >
                {hasIcon ? (
                    <img src={buttonIcon} alt={IconText || 'Icon'} width="24" height="24" />
                ) : (
                    <span className='iconText'>{IconText}</span>
                )}
            </div>
        ) : (
            <div
                title={theTooltip}
                onClick={handleToggle}
                className={`expand-container d-flex gap-3 p-2 text-white`}
                style={{
                    backgroundColor: isSelected ? 'orange' : buttonColor || 'transparent', // Default to transparent if buttonColor is not set
                    color: textColor || 'white',
                    marginBottom: "10px",
                }}
            >
                {hasIcon ? (
                    <img className='iconText' src={buttonIcon} alt={IconText || 'Icon'} width="24" height="24" />
                ) : (
                    <span className='iconText'>{IconText}</span>
                )}
                <div
                 style={{
                    color: expandedColor || 'white',
                }}>{expandedText}</div>
            </div>
        )
    );
};

export default FBXButtonVertical;
